import React from 'react';
import { BtwText } from '../BtwText';
import { Stack } from '../Stack';
export function ContainerHeader({ subtitle, title }) {
    return (React.createElement(Stack, { width: "full", className: "border-b border-gray-200 pb-9" },
        React.createElement(Stack, { align: "start", gap: "1" },
            React.createElement(BtwText, { size: "xl", variant: "primary", weight: "semibold", className: "font-legacy" }, title),
            subtitle && (React.createElement(BtwText, { size: "sm", className: "font-legacy" }, subtitle)))));
}
